import { render, staticRenderFns } from "./academy.vue?vue&type=template&id=1cc2a51c&scoped=true"
import script from "./academy.vue?vue&type=script&lang=js"
export * from "./academy.vue?vue&type=script&lang=js"
import style0 from "./academy.vue?vue&type=style&index=0&id=1cc2a51c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc2a51c",
  null
  
)

export default component.exports